import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { Button, Form, Row, Col, Input, message, Select, Cascader, TreeSelect } from '@drip/drip-design';
import apis from '@/pages/mvp-panel/participant-data/apis';
import { filterConditions } from '@/common/utils';
import _ from 'lodash';
import MutltipleCascader from '@zero/multiple-caseader';

// @ts-ignore
import { MultiSelect, Select as JMTDSelect, Button as JMTDButton } from '@jd/jmtd';
// @ts-ignore
import { EntityDropdownOption } from '@jd/jmtd-pro';
import IconTip from '@/components/icon-tip';

const categoryDataTransform = (data: any) => {
  function format(tree: any, parentName: any) {
    for (let i = 0; i < tree.length; i++) {
      tree[i].parentName = parentName + tree[i].name;
      if (tree[i].children && tree[i].children.length > 0) {
        format(tree[i].children, tree[i].parentName + '/');
      }
    }
  }
  format(data, '');
  return data;
};

function FormItems(props: any) {
  const { onChange = () => {}, onChangeOriginFilter = () => {} } = props;
  const [form] = Form.useForm();
  const { itemType, filter, dataScopeFilter, originFilter } = props;
  const [data, setDate] = useState({
    platformCate1: [],
    brandList: [],
    shopList: [],
    cateTree: [],
    placeCd: [],
  });
  const [searchVal, setSearchVal] = useState<{ shopName?: string; brandName?: string }>({
    shopName: '',
    brandName: '',
  });
  const [shopValue, setShopValue] = useState('');
  const [searchShopValue, setShopSearchValue] = useState('');

  const [brandValue, setBrandValue] = useState('');
  const [searchBrandValue, setBrandSearchValue] = useState('');

  const [defaultDept, setDefaultDept] = useState('')
  const [defaultErp, setDefaultErp] = useState('')

  useEffect(() => {
    if (!form) return;
    const value = form.getFieldsValue(true);
    form.setFieldsValue(Object.assign({}, value, { sku_id: '', spu_id: '' }));
  }, [itemType, form]);

  //监听外部头部变化
  useEffect(() => {
    if (!form) return;
    if (!originFilter) return;
    const { userType } = originFilter;
    let dept: any;
    let erp: any;
    if ((userType == 'dept' || userType == 'placeDept')) {
      dept = originFilter.dept ?? '';
    } else if ((userType == 'placeErp' || userType == 'erp')) {
      erp = originFilter.erp ?? ''
    }
    if(dept !== defaultDept){
      setDefaultDept(dept);
    }
    if(erp !== defaultErp){
      setDefaultErp(erp);
    }
    // console.log({ originFilter, erp, dept });
  }, [originFilter, form]);

  useEffect(() => {
    if (!form) return;
    form.resetFields();
  }, [filter, form]);

  useEffect(() => {
    if (!filter) return;
    apis
      .queryGeneralBrandAndShopList({ ...filter, ...searchVal, brandName: searchBrandValue, shopName: searchShopValue})
      .then((res) => {
        const { ret, msg } = res;
        if (ret !== '0' || !res.data) throw msg || '品类接口出错！';
        let brandList = res.data.brandList;
        // 转化数据就是 brandName->label brandCode->value
        const dataStr = JSON.stringify(brandList)
          .replace(/brandName/g, 'label')
          .replace(/brandCode/g, 'value');
        brandList = JSON.parse(dataStr);
        res.data.brandList = brandList;

        let shopList = res.data.shopList;
        // 转化数据就是 shopName->label shopId->value
        const shopStr = JSON.stringify(shopList)
          .replace(/shopName/g, 'label')
          .replace(/shopId/g, 'value');
        shopList = JSON.parse(shopStr);
        res.data.shopList = shopList;
        res.data.placeCd = _.isNil(res.data.placeCd) ? res.data.placeCd :  categoryDataTransform(res.data.placeCd);
        props.setPlaceList(res.data.placeCd);
        setDate(res.data);
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, [filter, searchVal, searchBrandValue, searchShopValue]);

  const onFinish = (value: any) => {
    let { cate_4, place, sku_id, spu_id, shop, main_brand, platform_cate_1, dept, erp } = value;
    let first_place_cd: string = '';
    let second_place_cd: string = '';
    let third_place_cd: string = '';
    let platform_cate = platform_cate_1 ? platform_cate_1.map((item:any)=>item.value) : [];
    const platform_cate_name = platform_cate_1 ? platform_cate_1.map((item:any)=>item.label) : ''
    props.setPlanList(platform_cate_name);
    props.setSelPlaceList(place)

    if (place) {
      if (place.length === 1) {
        first_place_cd = place[0];
      }
      if (place.length === 2) {
        second_place_cd = place[1];
      }
      if (place.length === 3) {
        third_place_cd = place[2];
      }
    }
    onChange(
      filterConditions({
        sku_id: sku_id ? [sku_id] : '',
        spu_id: spu_id ? [spu_id] : '',
        shop,
        main_brand,
        platform_cate_1: platform_cate ? platform_cate : [],
        cate_4,
        first_place_cd,
        second_place_cd,
        third_place_cd,
      })
    );
    if(!_.isEmpty(dept) || !_.isEmpty(erp)){
      onChangeOriginFilter({
        dept: dept,
        erp: erp,
      })
    }
  };

  const onBrandNameSearch = useMemo(() => {
    const change = (val: string) => {
      setSearchVal({ brandName: val });
    };
    return _.debounce(change, 800);
  }, []);

  const onShopNameSearch = useMemo(() => {
    const change = (val: string) => {
      setSearchVal({ shopName: val });
    };
    return _.debounce(change, 800);
  }, []);

  // 使用dataRender筛选显示的选项
  const searchDataRender = useCallback(() => {
    if (searchBrandValue) {
      return data.brandList.filter(
        (item: any) =>item['label'].includes(searchBrandValue) || item['value'].includes(searchBrandValue),
      );
    }
    return data.brandList;
  }, [searchBrandValue, data.brandList]);

  const searchShopDataRender = useCallback(() => {
    if (searchShopValue) {
      return data.shopList.filter(
        (item: any) =>item['label'].includes(searchShopValue) || item['value'].includes(searchShopValue),
      );
    }
    return data.shopList;
  }, [searchShopValue, data.shopList]);
  return (
    <Form form={form} onFinish={onFinish} key={JSON.stringify(data)}>
      <Row gutter={16}>
        <Col span={6}>
          {itemType == '1' ? (
            <Form.Item name="sku_id" label="SKUID">
              <Input placeholder="请输入" allowClear />
            </Form.Item>
          ) : (
            <Form.Item name="spu_id" label="SPUID">
              <Input placeholder="请输入" allowClear />
            </Form.Item>
          )}
        </Col>
        <Col span={6}>
          <Form.Item name="platform_cate_1" label={
                      <span>
                        平台
                        <IconTip title="平台维度多选后所有主题下的数据直接相加，流量数据不去重" />
                      </span>
          }>
            <Select mode="multiple" placeholder="请选择" allowClear labelInValue>
              {data.platformCate1?.map((item: any) => (
                <Select.Option value={item.code} key={item.code}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="品类"
            name="cate_4"
            rules={[
              {
                validator: (a: any, val) => {
                  return new Promise((resolve, reject) => {
                    if (!val) return resolve(1);
                    if (val.length > 100) return reject('最多选择100项');
                    return resolve(1);
                  });
                },
              },
            ]}
          >
            <MutltipleCascader
              fieldNames={{ label: 'name', value: 'key' }}
              options={data.cateTree || []}
              multiple
              placeholder="请选择"
              maxTagCount="responsive"
              expandTrigger="hover"
              showArrow
              allowClear
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label="品牌"
            name="main_brand"
            rules={[
              {
                validator: (a: any, val) => {
                  return new Promise((resolve, reject) => {
                    if (!val) return resolve(1);
                    if (val.length > 100) return reject('最多选择100项');
                    return resolve(1);
                  });
                },
              },
            ]}
          >
            <JMTDSelect
              render={MultiSelect}
              data={data.brandList}
              value={brandValue}
              onChange={setBrandValue}
              width={'100%'}
              showLength={true}
              showSearch={true}
              // searchValue={searchVal.brandName}
              searchValue={searchBrandValue}
              dataRender={searchDataRender}
              onSearch={setBrandSearchValue}

              optionRender={({ label, value }: any, searchValue: any) => {
                return (
                  <EntityDropdownOption valueLabel='品牌ID' value={value} keyword={searchValue}>
                    {label}
                  </EntityDropdownOption>
                )
              }
              }
            />

          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="shop"
            label="店铺"
            rules={[
              {
                validator: (a: any, val) => {
                  return new Promise((resolve, reject) => {
                    if (!val) return resolve(1);
                    if (val.length > 100) return reject('最多选择100项');
                    return resolve(1);
                  });
                },
              },
            ]}
          >
            <JMTDSelect
              render={MultiSelect}
              data={data.shopList}
              value={shopValue}
              onChange={setShopValue}
              width={'100%'}
              showLength={true}
              showSearch={true}
              searchValue={searchShopValue}
              dataRender={searchShopDataRender}
              onSearch={setShopSearchValue}
              optionRender={({ label, value }: any, searchValue: any) => {
                return (
                  <EntityDropdownOption valueLabel='店铺ID' value={value} keyword={searchValue}>
                    {label}
                  </EntityDropdownOption>
                )
              }
              }
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="销售场维度" name="place">
            <Cascader
              fieldNames={{ label: 'name', value: 'key' }}
              options={data.placeCd || []}
              changeOnSelect
              placeholder="场销售视角下该维度才可筛选"
              showArrow
              allowClear
              expandTrigger="hover"
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          {/*shouldUpdate={(prevValue, curValue) => prevValue.userType !== curValue.level}*/}
          <Form.Item noStyle>
            {
              (filter?.userType == 'dept' || filter?.userType == 'placeDept') &&
              <Form.Item
                name="dept"
                label={
                  <span>
                        数据范围
                        <IconTip title="根据用户角色展示用户可以查看的数据范围" />
                      </span>
                }
              >
                <TreeSelect
                  defaultValue={defaultDept}
                  style={{ width: '100%' }}
                  // changeOnSelect
                  allowClear={false}
                  fieldNames={{ label: 'name', value: 'deptFullCode', children: 'children' }}
                  treeData={dataScopeFilter.dataScope[filter?.userType]}
                  treeNodeLabelProp="deptFullName"
                />
              </Form.Item>
            }
            {
              (filter?.userType == 'placeErp' || filter?.userType == 'erp') &&
              <Form.Item
                name="erp"
                label={
                  <span>
                        数据范围
                        <IconTip title="根据用户角色展示用户可以查看的数据范围" />
                      </span>
                }
              >
                <Select
                  style={{ width: 200 }}
                  defaultValue={defaultErp}
                  showSearch
                  filterOption={(input, option:any) => option.children.toLowerCase().includes(input.toLowerCase())}
                >
                  {dataScopeFilter.dataScope[filter?.userType]?.map((item:any) => (
                    <Select.Option value={item} key={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            }
          </Form.Item>
        </Col>

        <Col span={6}>
          <div className="analysis-form-btns">
            <JMTDButton htmlType="submit" semantic="primary"  onClick={() => {form.submit();}} clsTag={'h|keycount|yx_center_hzcp_1678258944439|17'}>
              查询
            </JMTDButton>
            <Button
              style={{ marginLeft: 10 }}
              onClick={() => {
                form.resetFields();
                form.submit();
              }}
            >
              重置
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default FormItems;
